<template>
  <div class="layout k-main">
    <layoutHeader v-if="info.flag" :info="info"></layoutHeader>
    <el-container class="k-container">
      <!-- <layoutAside v-if="info.flag" :info="info"></layoutAside> -->
      <div class="k-container-main">
        <router-view v-if="info.flag" :info="info"></router-view>
      </div>
    </el-container>
	<el-dialog
	  :title="readContent.title"
	  :visible.sync="newsDialogVisible"
	  width="80%"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  :show-close="false"
	  center>
	  <div class="newsCon">
		  <div class="tips">添加人:{{readContent.uid_txt}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;添加时间:{{readContent.create_time}}<div class="time" v-if="readContent.read_time>0">强制阅读时间{{readContent.read_time}}秒</div></div>
		  <div v-html="readContent.content" class="content">
		  </div>
	  </div>
	  <span slot="footer" class="dialog-footer" style="display: flex;justify-content: right; align-items: center;">
		<p class="checked">
			<el-checkbox v-model="newsChecked">我已阅读</el-checkbox>
		</p>
		<el-button type="primary" :disabled="readContent.read_time > 0" @click="newsClose" size="mini">
			<template v-if="this.readNewsList.length != this.key+1">下一篇</template>
			<template v-else>关闭</template>
			<template v-if="readContent.read_time > 0">{{readContent.read_time}}s</template>
		</el-button>
	  </span>
	</el-dialog>
  </div>
</template>


<script>
// import layoutAside from './aside/aside'
import layoutHeader from '../layout/header/header.vue'

export default {
  name: 'layout',
  components: {
    layoutHeader
  },
  data() {
    return {
		newsDialogVisible: false,
		newsChecked:false,
		readNewsList:[],
		readContent:{},
		key:0,
      info: {
        flag: false,
        views: {
          isManager: '',
		      is_read:1,
          isSupper: '',
          routes: [],
          menus: [],
          actions: [],
          user: [],
          users:[],
		  version:''
        },
		userInfo: {
		  department_name: '',
		  position_name: '',
		  user_name: '',
      user_auth:[]
		},
        menus: [],
        size: 'mini',
        changePassFormVisiable: false,
        indexClic: '0',
        clickMenus: [],
        defaultUrl: '/',
        defaultOpeneds: [],
        changePassForm: {
          password: '',
          new_password: '',
          re_new_password: ''
        },
        rules: {
          password: [
            {
              required: true,
              message: '请填写当前密码',
              trigger: ['change', 'blur']
            }
          ],
          new_password: [
            {
              required: true,
              message: '请填写新密码',
              trigger: ['change', 'blur']
            },
            {
              validator: function(rule, value, callback) {
                if (value.length < 8) {
					callback(new Error('密码长度必须是8-12位!'))
				}else if (!/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/\d/.test(value)) {
					callback(new Error('密码必须含有大小写字母及数字!'))
				}else {
                  callback()
                }
              }.bind(this),
              trigger: ['change', 'blur']
            }
          ],
          re_new_password: [
            {
              required: true,
              message: '请再次填写新密码',
              trigger: ['change', 'blur']
            },
            {
              validator: function(rule, value, callback) {
                if (value !== this.info.changePassForm.new_password) {
                    callback(new Error('两次输入密码不一致!'))
                }else if (value.length < 8) {
					callback(new Error('密码长度必须是8-12位!'))
				}else if (!/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/\d/.test(value)) {
					callback(new Error('密码必须含有大小写字母及数字!'))
				}else {
                    callback()
                }
              }.bind(this),
              trigger: ['change', 'blur']
            }
          ]
        }
      }
    }
  },
  mounted: function() {
    this.getMenuList()
	this.getReadNews()
  },
  watch: {
	'$route'(to, from) {
      // 根据路由名称或路径更新菜单的激活状态
      var path = to.name
      if (path == 'Index') {
        this.info.clickMenus = res.data.menu_lists[0].children
        this.info.indexClic = 0
      } else {
        this.info.views.menus.forEach(
          function(item, index) {
            var urls = item.children.map(x => x['url_name'])
            var ind = urls.indexOf(path)
            if (ind != -1) {
              this.info.clickMenus = this.info.views.menus[index].children
              this.info.indexClic = index
            }
          }.bind(this)
        )
      }
  	}
	},
  methods: {
	getNoReadmessage:function(){
      this.$api.get('/admin/users/user/getnoreadmessage').then(res => {
        if(res.code === 0){
            this.info.views.is_read = res.data.is_read
			      this.info.views.check_num = res.data.check_num
        }
      })
    },
    isAuthAction: function(action) {
      return this.info.views.isSupper ? true : this.info.views.actions.indexOf(action.split('/').join(':').toLowerCase()) > -1
    },
    getMenuList: function() {
		this.$api.get('/admin/users/user/getauthinfos').then(res => {
			if (res.code === 0) {
			  this.info.views.actions = res.data.action_lists
			  this.info.views.user = res.data.user_info
			  this.info.views.menus = res.data.menu_lists
			  this.info.views.users = res.data.user_lists
			  this.info.views.version = res.data.version
			  this.info.views.admin_user = res.data.admin_user
			  this.info.views.is_supper = res.data.is_supper
			  if(res.data.is_supper == 'ADMIN'){
				  this.info.views.isManager = false
				  this.info.views.isSupper = true
			  }else{
				  this.info.views.isManager = true
				  this.info.views.isSupper = false
			  }
			  this.info.views.is_test = res.data.is_test
			  this.info.views.is_read = res.data.is_read
			  this.info.views.check_num = res.data.check_num
			  var path = this.$route.path
			  if (path == '/') {
			    this.info.clickMenus = res.data.menu_lists[0].children
			    this.info.indexClic = 0
			  } else {
			    this.info.views.menus.forEach(
			      function(item, index) {
			        var urls = item.children.map(x => x['menu_url'])
			        var ind = urls.indexOf(path)
			        if (ind != -1) {
			          this.info.clickMenus = this.info.views.menus[index].children
			          this.info.indexClic = index
			        }
			      }.bind(this)
			    )
			  }
			} else {
			  this.$notify({
				  showClose: true,
				  message: res.msg,
				  type: 'warning'
			  });
			}
			this.loading = false
		})
	  this.info.flag = true
    },
	getReadNews(){
		this.$api.get('/admin/news/message/getnoticereadlist').then(res => {
		  if (res.code === 0) {
			  this.readNewsList = res.data.unReadList
			  if(this.readNewsList.length > 0){
				  this.newsDialogVisible = true
				  this.getData()
			  }else{
				  this.newsDialogVisible = false
			  }
		  }
		})
	},
	getData(){
		this.readContent = this.readNewsList[this.key]
		if(this.readContent.read_time > 0){
			this.startCountdown()
		}
	},
	startCountdown() {
	  const interval = setInterval(() => {
		if (this.readContent.read_time > 0) {
		  this.readContent.read_time--;
		} else {
		  clearInterval(interval); //倒计时结束时清除定时器
		}
	  }, 1000);
	},
	newsClose(){
		if(this.newsChecked){
			this.$api.get('/admin/news/message/readnotice',{id:this.readContent.id}).then(res => {
			    if (res.code === 0) {
					if(this.readNewsList.length == this.key+1){
						this.newsDialogVisible = false
						this.key = 0
					}else{
						this.key++
						this.newsChecked = false
						this.getData()
					}
			    }else{
					this.$message.error(res.msg);
				}
			})
		}else{
			this.$message.error('如您已全部阅读完成，请勾选我已阅读，谢谢！');
		}
	}
  }
}
</script>
<style lang="scss">
.k-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  .k-container {
    position: relative;
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-direction: row;
    .k-container-main {
      position: relative;
      flex: 1;
      overflow: auto;
      background: #f8f8f7;
    }
  }
}
.checked{
		margin-right: 15px;
		.el-checkbox{
			font-weight: normal !important;
		}
	}
.newsCon{
	.tips{
		border-bottom: 1px solid #DCDFE6;
		font-size: 14px;
		color: #000;
		text-align: center;
		padding-bottom: 10px;
		position: relative;
		.time{
			position: absolute;
			top: 0;
			right: 0;
			font-size: 14px;
			color: #F56C6C;
		}
	}
	.content{
		height: calc(70vh - 120px);
		overflow: auto;
		line-height: 24px;
		font-size: 14px;
		color: #000;
		padding: 20px 0;
		box-sizing: border-box;
		margin-top: 20px;
		img{
			max-width: 100%;
		}
	}
}
</style>